<!-- <div class="overlay-wrapper fw fh" [hidden]="!showOverlay">
    <div class="loader"></div>
    <span class="message" *ngIf="message">{{message}}</span>
</div> -->
<div class="spinner-wrapper fw fh" *ngIf="showLoader">
    <div class="loader"></div>
</div>